import React, { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import { ErrorBanner } from '../../components'
import { errorStringsFromError } from 'utils'
import { ProjectActions } from '../../actionsets'
import { useActions } from 'hooks'
import { connect } from 'react-redux'

const ReCodeButton = ({ dispatch, projectId, reloadTasks }) => {
  const [open, setOpen] = useState(false)
  const [oldPrefix, setOldPrefix] = useState('')
  const [newPrefix, setNewPrefix] = useState('')
  const [errors, setErrors] = useState([])
  const actions = useActions(dispatch, ProjectActions)

  const handleOpen = () => {
    setErrors([])
    setOldPrefix('')
    setNewPrefix('')
    setOpen(true)
  }

  const handleConfirm = async () => {
    try {
      await actions.recodeProjectTasks(projectId, { oldPrefix: oldPrefix, newPrefix: newPrefix })
      if (reloadTasks) {
        reloadTasks()
      }
      setOpen(false)
    } catch (err) {
      setErrors(errorStringsFromError(err?.body?.errors || []))
    }
  }

  return <>
    <Button
      color="secondary"
      variant="contained"
      children='Re-Code'
      style={{ float: 'right', marginLeft: 10 }}
      onClick={handleOpen}
    />
    <Dialog open={open} onCancel={() => setOpen(false)}>
      <DialogTitle>Re-Code Project Tasks</DialogTitle>
      <DialogContent>
        <ErrorBanner>{errors}</ErrorBanner>
        <br />
        <TextField fullWidth label="Old Prefix" value={oldPrefix} onChange={({ target: { value } }) => setOldPrefix(value?.toUpperCase())} />
        <TextField fullWidth label="New Prefix" value={newPrefix} onChange={({ target: { value } }) => setNewPrefix(value?.toUpperCase())} />
        <br />
      </DialogContent>
      <DialogActions>
        <Button color="white" variant="contained" onClick={() => setOpen(false)}>Cancel</Button>
        <Button disabled={!(oldPrefix && newPrefix)} variant="contained" onClick={handleConfirm}>Confirm</Button>
      </DialogActions>
    </Dialog>
  </>
}

export default connect()(ReCodeButton)